export enum QuestionnaireState {
  COMPLETE = "COMPLETE",
  TOUCHED = "TOUCHED",
  UNTOUCHED = "UNTOUCHED",
}
